import { cartServices, helpers, meetingServices, notificationServices, publicMinistryServices, userServices } from 'src/services';
import { FailedToGetData, H2, Loading, RadioSelector } from 'src/components/_commons';
import { NotificationsCarts } from './subcomponents/NotificationsCarts';
import { NotificationsMeetingsMidweek } from './subcomponents/NotificationsMeetingsMidweek';
import { NotificationsMeetingsPublic } from './subcomponents/NotificationsMeetingsPublic';
import { NotificationsPublicMinistry } from './subcomponents/NotificationsPublicMinistry';
import { NotificationsTodayButton } from './subcomponents/NotificationsTodayButton';
import { notificationTypes } from '@monorepo/helpers';
import { setAlertResponse } from 'src/store';
import { typeCartsDoc, typeMeetingsDoc, typeNotificationsDoc, typeNotificationType, typePublicMinistryDoc, typeUser } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';

export const AdminsNotifications = () => {
    const [cartsDoc, setCartsDoc] = useState<typeCartsDoc | null>(null);
    const [isLoading1, setIsLoading1] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [isLoading3, setIsLoading3] = useState(true);
    const [isLoading4, setIsLoading4] = useState(true);
    const [isLoading5, setIsLoading5] = useState(true);
    const [meetingsDoc, setMeetingsDoc] = useState<typeMeetingsDoc | null>(null);
    const [notificationsDoc, setNotificationsDoc] = useState<typeNotificationsDoc | null>(null);
    const [publicMinistryDoc, setPublicMinistryDoc] = useState<typePublicMinistryDoc | null>(null);
    const [radioValue, setRadioValue] = useState<typeNotificationType | null>(null);
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [users, setUsers] = useState<typeUser[] | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    useEffect(() => {
        helpers.GoToTop();
        setIsLoading1(true);
        notificationServices.Get().then(response => {
            setIsLoading1(false);
            if (!response.success || !response.data?.notificationsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setNotificationsDoc(response.data.notificationsDoc);
        });
    }, [refreshCounter]);

    useEffect(() => {
        cartServices.Get().then(response => {
            setIsLoading2(false);
            if (!response.success || !response.data?.cartsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCartsDoc(response.data.cartsDoc);
        });
    }, []);

    useEffect(() => {
        meetingServices.Get().then(response => {
            setIsLoading3(false);
            if (!response.success || !response.data?.meetingsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setMeetingsDoc(response.data.meetingsDoc);
        });
    }, []);

    useEffect(() => {
        publicMinistryServices.Get().then(response => {
            setIsLoading4(false);
            if (!response.success || !response.data?.publicMinistryDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setPublicMinistryDoc(response.data.publicMinistryDoc);
        });
    }, []);

    useEffect(() => {
        userServices.GetAll().then(response => {
            setIsLoading5(false);
            if (!response.success || !response.data?.users) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setUsers(response.data.users);
        });
    }, []);

    if (isLoading1 || isLoading2 || isLoading3 || isLoading4 || isLoading5) {
        return <Loading mt={'80px'} />;
    }

    if (!notificationsDoc || !cartsDoc || !meetingsDoc || !publicMinistryDoc || !users) {
        return <FailedToGetData />;
    }

    return (
        <div className={isDarkMode ? 'text-white' :''}>
            <H2 title={'NOTIFICACIONES'} />
            <NotificationsTodayButton
                notifications={notificationsDoc.notifications}
                setRefreshCounter={setRefreshCounter}
                users={users}
            />
            <RadioSelector
                options={notificationTypes.filter(nt => nt.isFirstPage)}
                radioValue={radioValue}
                setRadioValue={setRadioValue}
            />
            {radioValue === 'carts' &&
                <NotificationsCarts
                    cartsDoc={cartsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-midweek-assignment' &&
                <NotificationsMeetingsMidweek
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'meetings-public-assignment' &&
                <NotificationsMeetingsPublic
                    meetingsDoc={meetingsDoc}
                    notificationsDoc={notificationsDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
            {radioValue === 'public-ministry' &&
                <NotificationsPublicMinistry
                    notificationsDoc={notificationsDoc}
                    publicMinistryDoc={publicMinistryDoc}
                    setRefreshCounter={setRefreshCounter}
                    users={users}
                />
            }
        </div>
    );
}
